import React from "react";
import styled from "styled-components";
import I10n from "../features/i10n";
import InformationIcon from "../atoms/information-icon";
import Toggle from "./toggle";
import MsxIcons from "../features/msx-icons";
import Tooltip from "./documentation/tootip";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ToggleLabel = styled.div`
  font-size: 18px;
  font-weight: 400;
  white-space: nowrap;
  margin: 0px 5px;
  color: #181A1B;
`;

const MenuWrapper = styled.div`
  position: relative;
  cursor: pointer;
  color: #000000;
`;

const TootltipContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  color: #0F0F0F;
  padding: 10px 10px 5px 10px;
  background-color: #D9D9D9;
`;

const TooltipHeader = styled.div`
  display: flex;
  align-items: center;
`;

const TooltipTitle = styled.span`
  font-size: 14px;
  font-weight: 700;
  margin-left: 5px;
`;

const TooltipDescription = styled.span`
  font-size: 14px;
  font-weight: 400;
`;

class PrecommercializationWarning extends React.Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount = () => {};

  render = () => {
    return (
      <Wrapper>
        <Toggle
          active={this.props.showPrecommercializedProducts}
          disabled={this.props.disabled}
          onToggle={() => {
            if (!this.props.disabled) {
              this.props.onToggle();
            }
          }}
        ></Toggle>
        <ToggleLabel>
          {I10n.get("precommercialization.all_products")}
        </ToggleLabel>
        <MenuWrapper>
          <Tooltip
            toggleElement={<InformationIcon></InformationIcon>}
            containerElement={
              <TootltipContent>
                <TooltipHeader>
                  <MsxIcons name="info_hover"></MsxIcons>
                  <TooltipTitle>{I10n.get('precommercialization.tooltip.title')}</TooltipTitle>
                </TooltipHeader>
                <TooltipDescription>
                  {I10n.get('precommercialization.tooltip.body')}
                </TooltipDescription>
              </TootltipContent>
            }
            boundingElement={this.props.boundingElement}
            triangleColor={'#D9D9D9'}
          ></Tooltip>
        </MenuWrapper>
      </Wrapper>
    );
  };
}
export default PrecommercializationWarning;
